import React from "react";
import { IMAGES } from "../../utils/images";
import "../../Styles/DashboardCourses.css";

const DashboardCourses = () => {
  return (
    <div className="dashboard-content">
      <div className="home-heading-container">
        <h1 className="heading-text-h1">Your Courses</h1>
        <p className="heading-text-p">Welcome to srimedutech Dashboard</p>
      </div>
      <hr className="dashboard-home-hr" />
      <div className="dash-courses-card">
        <img src={IMAGES.DASHBOARD_COURSE} alt="course-image" className="course-image"/>
        <div className="course-bottom">
          <h2 className="course-heading">Javascript</h2>
          <div className="progressbar">
            <img src={IMAGES.HOME_ICON_1} />
            <p className="progressbar-text">01 Nov 2024 - 01 Feb 2025</p>
          </div>
          <div className="progressbar">
            <div className="progressbar-outter">
              <div className="progressbar-inner"></div>
            </div>
            <p className="progressbar-text">70%</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCourses;
